import { Injectable } from '@angular/core';
import { eventActions, ISourceOfOperation } from '../constants';
import { IProduct, IDeviceProducts, IRecommendedProducts, IBillingInfo, IShippingInfo, IPaymentInfo,
     IPaymentMaskedInfo, IDiscountData, IFinalOrderSummaryInfo, IAutoRenewal, IOrderSummaryResponse, IPreorderResponse } from '../interfaces/data-micro-ui-interface';
import { microUI, termsAndConditionsInfo } from '../constants';
@Injectable({
    providedIn: 'root'
})
export class DataService {

    private BASE_URL: string;
    private TAX_YEAR: string;
    private PRICE_GROUP_KEY: string;
    private SKU: string;
    private STATE: string;
    private PROMO_CODE: string;
    private CLIENT_IP: string;
    private serviceId: string;
    private productDetailsInfo : IProduct;
    private recommendedProductsInfo : IRecommendedProducts[];
    private deviceTypeInfo : string;
    private billingInfo : IBillingInfo;
    private shippingInfo : IShippingInfo;
    private paymentInfo : IPaymentInfo;
    private paymentMaskedInfo: IPaymentMaskedInfo;
    private backUpCd : boolean;
    private autoRenewalTermsAndConditions : boolean;
    private taxIdentityShieldTermsAndConditions : boolean;
    private termsAndConditions : string = "";
    private discountData: IDiscountData[];
    private finalOrderSummaryData : IFinalOrderSummaryInfo;
    private autoRenewal : IAutoRenewal | undefined;
    private autoRenewalChecked : boolean;
    private autoRenewalInformation : IAutoRenewal;
    private deviceProductsInformation : IDeviceProducts;
    private transactionUuid: string;
    private orderSummaryResponse: IOrderSummaryResponse;
    private preOrderDate: IPreorderResponse;
    private showPaymentForm : boolean;
    private emailRequired: boolean;
    private zipCodePlusFourValidation: boolean;
    private deviceSelection: string;

    constructor() {
        this.emailRequired = true;
        this.zipCodePlusFourValidation = true;
     }

    public setBaseUrl(BASE_URL : string){
        this.BASE_URL = BASE_URL;
    }

    public getBaseUrl(){
        return this.BASE_URL;
    }

    public setTaxYear(TAX_YEAR : string){
        this.TAX_YEAR = TAX_YEAR;
    }

    public getTaxYear(){
        return this.TAX_YEAR;
    }

    public setPriceGroupKey(PRICE_GROUP_KEY : string){
        this.PRICE_GROUP_KEY = PRICE_GROUP_KEY;
    }

    public getPriceGroupKey(){
        return this.PRICE_GROUP_KEY;
    }

    public setSku(SKU : string){
        this.SKU = SKU;
    }

    public getSku(){
        return this.SKU;
    }

    public setState(STATE : string){
        this.STATE = STATE;
    }

    public getState(){
        return this.STATE;
    }

    public setDeviceSelection(device : string){
        this.deviceSelection = device;
    }

    public getDeviceSelection(){
        return this.deviceSelection;
    }

    public setPromoCode(PROMO_CODE : string){
        this.PROMO_CODE = PROMO_CODE;
    }

    public getPromoCode(){
        return this.PROMO_CODE;
    }

    public setClientIp(CLIENT_IP : string){
        this.CLIENT_IP = CLIENT_IP;
    }

    public getClientIp(){
        return this.CLIENT_IP;
    }

    public setServiceId(serviceId : string){
        this.serviceId = serviceId;
    }

    public setAutoRenewal(autoRenewal : IAutoRenewal | undefined) {
        this.autoRenewal = autoRenewal;
        const activated = this.autoRenewalChecked = autoRenewal !== null;
        this.toggleAutoRenewalTermsAndConditions(activated);
    }

    public getAutoRenewal() {
        return this.autoRenewal;
    }

    public setAutoRenewalInformation(autoRenewalInfo : IAutoRenewal) {
        this.autoRenewalInformation = autoRenewalInfo;
    }

    public getAutoRenewalInformation(){
        return this.autoRenewalInformation;
    }

    public setOrderSummaryResponse(orderSummaryResponse: IOrderSummaryResponse) {
        this.orderSummaryResponse = orderSummaryResponse;
    }

    public getOrderSummaryResponse() {
        return this.orderSummaryResponse;
    }

    public getServiceId(){
        return this.serviceId;
    }

    public setTermsAndConditions(){
        if(this.autoRenewalTermsAndConditions && this.taxIdentityShieldTermsAndConditions){
            this.termsAndConditions = termsAndConditionsInfo.showBothTerms;
        }else if (this.autoRenewalTermsAndConditions){
            this.termsAndConditions = termsAndConditionsInfo.showAutoRenewalTerms;
        }else if (this.taxIdentityShieldTermsAndConditions){
            this.termsAndConditions = termsAndConditionsInfo.showTaxIdentityShieldTerms;
        } else {
            this.termsAndConditions = "";
        }
    }

    public getTermsAndConditions(){
        return this.termsAndConditions;
    }

    public setPrductDetailsInfo(product : IProduct){
        this.productDetailsInfo = product;
    }

    public getProductDetailsInfo() {
        return this.productDetailsInfo;
    }

    public getProductDescription() {
        return this.productDetailsInfo.description;
    }

    public setPreOrder(date : IPreorderResponse){
        this.preOrderDate = date;
    }

    public getPreOrder() {
        return this.preOrderDate;
    }

    public setShowPaymentForm(show : boolean){
        this.showPaymentForm = show;
    }

    public getShowPaymentForm() {
        return this.showPaymentForm;
    }


    public setDeviceProductsInfo(deviceProducts : IDeviceProducts){
        this.deviceProductsInformation = deviceProducts;
    }

    public getDeviceProductsInfo(){
        return this.deviceProductsInformation;
    }

    public addToRecommendedProductsInfo(recommendedProduct: IRecommendedProducts){
        if(recommendedProduct.description == 'Tax Identity Shield'){
            this.taxIdentityShieldTermsAndConditions = true;
            this.setTermsAndConditions();
        }
        if(recommendedProduct.description == 'Backup CD')
            this.backUpCd = true;
        this.recommendedProductsInfo = this.recommendedProductsInfo.map(p=>
            p.sku === recommendedProduct.sku ? {...p, added: true} : p);
    }

    public removeToRecommendedProductsInfo(recommendedProduct: IRecommendedProducts){
        if(recommendedProduct.description == 'Tax Identity Shield'){
            this.taxIdentityShieldTermsAndConditions = false;
            this.setTermsAndConditions();
        }
        if(recommendedProduct.description == 'Backup CD')
            this.backUpCd = false;
        this.recommendedProductsInfo = this.recommendedProductsInfo.map(p=>
            p.sku === recommendedProduct.sku ? {...p, added: false} : p);
    }

    public toggleAutoRenewalTermsAndConditions(autorenewal : boolean){
        this.autoRenewalTermsAndConditions = autorenewal;
        this.setTermsAndConditions();
    }

    public toggleAutoRenewal() {
        return this.autoRenewal !== null;
    }

    public setRecommendedProductsInfo(recommendedProducts : IRecommendedProducts[]){
        this.recommendedProductsInfo = recommendedProducts;
    }

    public getRecommendedProductsInfo() {
        return this.recommendedProductsInfo;
    }

    public setDeviceTypeInfo(deviceType : string){
        this.deviceTypeInfo = deviceType;
    }

    public getDeviceTypeInfo() {
        return this.deviceTypeInfo;
    }

    public setEmailRequired(email : boolean){
        this.emailRequired = email;
    }

    public getEmailRequired() {
        return this.emailRequired;
    }

    public setZipCodePlusFour(flag : boolean){
        this.zipCodePlusFourValidation = flag;
    }

    public getZipCodePlusFour() {
        return this.zipCodePlusFourValidation;
    }

    public setBillingInfo(billing : IBillingInfo){
        this.billingInfo = billing;
    }

    public getBillingInfo() {
        return this.billingInfo;
    }

    public getBillingEmail() {
        return this.billingInfo.email;
    }

    public setShippingInfo(shipping : IShippingInfo){
        this.shippingInfo = shipping;
    }

    public getShippingInfo() {
        return this.shippingInfo;
    }

    public setPaymentInfo(payment : IPaymentInfo) {
        this.paymentInfo = payment;
    }

    public getPaymentInfo() {
        return this.paymentInfo;
    }

    public setPaymentMaskedInfo(paymentMasked : IPaymentMaskedInfo) {
        this.paymentMaskedInfo = paymentMasked;
    }

    public getPaymentMaskedInfo() {
        return this.paymentMaskedInfo;
    }

    public getBackUpCdInfo() {
        return this.backUpCd;
    }

    public getDiscountData(){
        this.discountData = this.recommendedProductsInfo ? this.recommendedProductsInfo.filter(p=> p.added).map(p=> ({ sku: p.sku, price: p.priceGroupPrice })) : [];
        this.discountData.push({ sku: this.productDetailsInfo.sku, price: this.productDetailsInfo.priceGroupPrice });
        return this.discountData;
    }

    public getFinalOrderSummaryData(){
        const billingData = this.getBillingInfo();
        this.finalOrderSummaryData = {
            billingInfo: {
                ...billingData,
                backUpCD: this.getBackUpCdInfo()
            },
            shippingInfo: billingData.sameAddress ? billingData : this.getShippingInfo(),
            paymentInfo: this.getPaymentMaskedInfo()
        }
        return this.finalOrderSummaryData;
    }

    public setTransactionUuid(uuid: string){
        this.transactionUuid = uuid;
    }

    public getTransactionUuid() {
        return this.transactionUuid;
    }

    public getActivationRequestData(){
        const productInfo = this.getProductDetailsInfo();
        const billingInfo = this.getBillingInfo();
        return {
            id: productInfo.sku,
            Price: productInfo.basePrice + "",
            uuid: this.transactionUuid,
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            street: (billingInfo.apartment) ? billingInfo.address + " " + billingInfo.apartment : billingInfo.address,
            city: billingInfo.city,
            state: billingInfo.state,
            zipCode: billingInfo.zip,
            email: billingInfo.email
        }
    }

    getComponentInfo(component, microName : string) {
        switch (microName) {
            case microUI.productDetails:
                if(this.productDetailsInfo) {
                    component[eventActions.productInfo] = this.getProductDetailsInfo();
                }
                if(this.deviceProductsInformation){
                    component[eventActions.deviceProductsInfo] = this.getDeviceProductsInfo();
                }
                if(this.deviceTypeInfo) {
                    component[eventActions.deviceTypeInfo] = this.getDeviceTypeInfo();
                }
                if(this.recommendedProductsInfo) {
                    component[eventActions.recommendedProductsInfo] = this.getRecommendedProductsInfo();
                }
                if(this.autoRenewalChecked) {
                    component[eventActions.autoRenewalChecked] = this.autoRenewalChecked;
                }
                if(this.autoRenewalInformation) {
                    component[eventActions.autoRenewalInformation] = this.getAutoRenewalInformation();
                }
                component.setAttribute(eventActions.base_url, this.getBaseUrl());
                component.setAttribute(eventActions.tax_year, this.getTaxYear());
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());
                component.setAttribute(eventActions.sku, this.getSku());
                component.setAttribute(eventActions.state, this.getState());
                component.setAttribute(eventActions.service, this.getServiceId());
                component.setAttribute(eventActions.client_ip, this.getClientIp());
                component.setAttribute(eventActions.devices_available, this.getDeviceSelection());
                component.setAttribute(eventActions.sourceOfOperation, ISourceOfOperation.softwareCart);
                return component;
            case microUI.billingAndPayment:
                if(this.billingInfo) {
                    component[eventActions.billingInfo] = this.getBillingInfo();
                }
                if(this.shippingInfo){
                    component[eventActions.shippingInfo] = this.getShippingInfo();
                }
                if(this.paymentInfo){
                    component[eventActions.paymentInfo] = this.getPaymentInfo();
                }
                component.setAttribute(eventActions.melissa_data, 'true');
                component.setAttribute(eventActions.base_url, this.getBaseUrl());
                component.setAttribute(eventActions.tax_year, this.getTaxYear());
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());
                component.setAttribute(eventActions.showPaymentForm, this.getShowPaymentForm());
                component.setAttribute(eventActions.preOrderDate, this.getPreOrder().preOrderEnabled);
                component.setAttribute(eventActions.backUpCdInfo, this.getBackUpCdInfo());
                component.setAttribute(eventActions.terms, this.getTermsAndConditions());
                component.setAttribute(eventActions.service, this.getServiceId());
                component.setAttribute(eventActions.client_ip, this.getClientIp());
                component.setAttribute(eventActions.emailRequired, this.getEmailRequired());
                component.setAttribute(eventActions.zipCodePlusFourValidation, this.getZipCodePlusFour());
                component.setAttribute(eventActions.payment_mode, 'cart');
                component.setAttribute(eventActions.sourceOfOperation, ISourceOfOperation.softwareCart.toString());
                component.setAttribute(eventActions.productInfo, this.getSku());
                console.log(component);
                return component;
            case microUI.couponCode:
                component.setAttribute(eventActions.base_url, this.getBaseUrl());
                component.setAttribute(eventActions.tax_year, this.getTaxYear());
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());
                component.setAttribute(eventActions.service, this.getServiceId());
                component.setAttribute(eventActions.client_ip, this.getClientIp());
                component.setAttribute(eventActions.sourceOfOperation, ISourceOfOperation.softwareCart.toString());
                component.setAttribute(eventActions.productInfo, this.getSku());
                return component;
            case microUI.orderSummary:
                component.setAttribute(eventActions.base_url, this.getBaseUrl());
                component.setAttribute(eventActions.tax_year, this.getTaxYear());
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());
                component.setAttribute(eventActions.service, this.getServiceId());
                component.setAttribute(eventActions.state, this.getState());
                component.setAttribute(eventActions.promocode, this.getPromoCode());
                component.setAttribute(eventActions.summary_mode, 'order');
                return component;
            case microUI.orderConfirmation:
                console.log("data.service:getComponentInfo, step 0 billingInfo");
                if(this.billingInfo) {
                  component[eventActions.billingInfo] = this.getBillingInfo();
                }

                console.log("data.service:getComponentInfo, step 1 product");
                component[eventActions.product] = this.getProductDetailsInfo();

                console.log("data.service:getComponentInfo, step 2 productAddons");
                component[eventActions.productAddons] = this.getRecommendedProductsInfo();

                console.log("data.service:getComponentInfo, step 3 base_url");
                component.setAttribute(eventActions.base_url, this.getBaseUrl());

                console.log("data.service:getComponentInfo, step 4 tax_year");
                component.setAttribute(eventActions.tax_year, this.getTaxYear());

                console.log("data.service:getComponentInfo, step 5 price_group_key");
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());

                console.log("data.service:getComponentInfo, step 6 billingInfoEmail");
                component.setAttribute(eventActions.billingInfoEmail, this.getBillingEmail());

                console.log("data.service:getComponentInfo, step 7 preOrderDate");
                component.setAttribute(eventActions.preOrderDate, this.getPreOrder().preOrderEnabled);

                console.log("data.service:getComponentInfo, step 8 service");
                component.setAttribute(eventActions.service, this.getServiceId());

                console.log("data.service:getComponentInfo, step 9 promocode");
                component.setAttribute(eventActions.promocode, this.getPromoCode());

                console.log("data.service:getComponentInfo, step 10 state");
                component.setAttribute(eventActions.state, this.getState());

                console.log("data.service:getComponentInfo, step 11 returning ...");
                component.setAttribute(eventActions.sourceOfOperation, ISourceOfOperation.softwareCart.toString());
                return component;
            default:
                component.setAttribute(eventActions.base_url, this.getBaseUrl());
                component.setAttribute(eventActions.tax_year, this.getTaxYear());
                component.setAttribute(eventActions.price_group_key, this.getPriceGroupKey());
                component.setAttribute(eventActions.service, this.getServiceId());
                component.setAttribute(eventActions.sourceOfOperation, ISourceOfOperation.softwareCart.toString());
                return component;
        }
    }
}
